import { atom } from "jotai";

export const isAuthAtom = atom(false);
